import React from "react";
import { Spinner } from "react-bootstrap";


const Fallback = () => {
    return (
        <div>

            <div
                className=" d-flex justify-content-center bg-white mt-3 align-items-center   flex-column"

                style={{
                    height: window.innerHeight / 1.15,
                    minHeight: 400,
                    backgroundColor: "red"
                }}>

                <Spinner
                    color="#fc6257"
                    height={100}
                    width={100}

                />
                Loading...!
            </div>
        </div>
    )
};

export default Fallback